import { gql } from "@apollo/client";

export const DELETE_LEGACY_FORM_TEMPLATE_RULE = gql`
  mutation DeleteLegacyFormTemplateRule(
    $formTemplateRuleIds: [uuid!]!
    $formTemplateId: uuid!
  ) {
    update_form_template_by_pk(
      pk_columns: { id: $formTemplateId }
      _set: { form_template_rule_id: null }
    ) {
      id
    }
    delete_status_rule_school(
      where: { rule: { form_template_rule_id: { _in: $formTemplateRuleIds } } }
    ) {
      affected_rows
    }
    delete_status_rule(
      where: { rule: { form_template_rule_id: { _in: $formTemplateRuleIds } } }
    ) {
      affected_rows
    }
    delete_rule(
      where: { form_template_rule_id: { _in: $formTemplateRuleIds } }
    ) {
      affected_rows
    }
    delete_form_template_rule(where: { id: { _in: $formTemplateRuleIds } }) {
      affected_rows
    }
  }
`;

export const UPDATE_LEGACY_FORM_TEMPLATE_RULE = gql`
  mutation UpdateLegacyFormTemplateRule(
    $formTemplateId: uuid!
    $formTemplateRuleId: uuid!
    $formTemplateRule: form_template_rule_insert_input!
    $rule: rule_insert_input!
    $statusRule: status_rule_insert_input!
    $schools: [status_rule_school_insert_input!]!
  ) {
    insert_form_template_rule_one(
      object: $formTemplateRule
      on_conflict: {
        constraint: form_template_rule_pkey
        update_columns: [operator]
      }
    ) {
      id
    }
    insert_rule_one(
      object: $rule
      on_conflict: { constraint: rule_pkey, update_columns: [type] }
    ) {
      id
    }
    insert_status_rule_one(
      object: $statusRule
      on_conflict: {
        constraint: status_rule_pkey
        update_columns: [
          type
          form_status
          offer_status
          waitlist_status
          schools_operator
          next_form_template_id
          next_step
        ]
      }
    ) {
      rule_id
    }
    delete_status_rule_school(
      where: { rule: { form_template_rule_id: { _eq: $formTemplateRuleId } } }
    ) {
      affected_rows
    }
    insert_status_rule_school(
      objects: $schools
      on_conflict: {
        constraint: status_rule_school_rule_id_school_id_key
        update_columns: [school_id]
      }
    ) {
      affected_rows
    }

    update_form_template_by_pk(
      pk_columns: { id: $formTemplateId }
      _set: { form_template_rule_id: $formTemplateRuleId }
    ) {
      id
    }
  }
`;
